import React from 'react';
import PropTypes from 'prop-types';
import FormField from './../FormField';
import CategoryField from './../CategoryField';
import RemovableRow from './../RemovableRow';
import ImmutablePropTypes from 'react-immutable-proptypes';

const CategoryFieldset = ({ member, index, fields, config, categories, maxPricingTier, pricingTiers, currentPricingTier }) => (
  <RemovableRow fields={fields} index={index}>
    <div className="col">
      <FormField
        name={`${member}.id`}
        component={CategoryField}
        inputProps={{ valueField: 'id', textField: 'name_with_path' }}
        type="text"
        className="form-control"
        config={config}
        placeholder="Select a category"
        categories={categories}
        maxPricingTier={maxPricingTier}
        pricingTiers={pricingTiers}
        currentPricingTier={currentPricingTier}
      />
    </div>
  </RemovableRow>
);

CategoryFieldset.propTypes = {
  formErrors: PropTypes.object,
  member: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  fields: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  categories: PropTypes.array.isRequired,
  maxPricingTier: PropTypes.number,
  pricingTiers: ImmutablePropTypes.map.isRequired,
  currentPricingTier: PropTypes.number,
};

export default CategoryFieldset;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/CategoryFieldset.jsx